import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconJoin } from '../../../../assets/status-screen-icons/icon-join';
import { Checkbox, DialogConfirmation } from '../../../../components';
import { useNativeFunctionsContext } from '../../../../context/native-functions';
import { environment } from '../../../../environment';
import * as storage from '../../../../integrations/lavva/storage';

export const NativeAppDialog: React.FC = () => {
  const { t: tc } = useTranslation('common');
  const [checked, toggleChecked] = useState<boolean>(false);
  const { nativeAppInstalledPopupOpen, setNativeAppInstalledPopupOpen } = useNativeFunctionsContext();

  const handleOpenNativeApp = () => {
    window.location.href = `https:${environment.PUBLIC_URL}/openApp`;

    setTimeout(() => handleCancel(false), 2000);
  };

  const handleToggle = () => toggleChecked(!checked);

  const handleCancel = (show: boolean) => {
    storage.setItem('remindNative', checked ? new Date() : null);
    setNativeAppInstalledPopupOpen(show);
  };

  return (
    <DialogConfirmation
      show={nativeAppInstalledPopupOpen}
      setShow={() => handleCancel(false)}
      header={tc('native.applicationInstalledPopup.header')}
      primaryBtnText={tc('buttons.continue')}
      secondaryBtnText={tc('buttons.cancel')}
      primaryBtnAction={handleOpenNativeApp}
      secondaryBtnAction={() => handleCancel(false)}
    >
      <IconJoin style={{ width: '100%', height: '120px' }} />
      <p className="m-b-32">{tc('native.applicationInstalledPopup.content')}</p>
      <Checkbox checked={checked} onChange={handleToggle} reverse>
        {tc('remindLater')}
      </Checkbox>
    </DialogConfirmation>
  );
};
